import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "../public/css/materialdesignicons.min.css";
import 'swiper/swiper-bundle.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { BootstrapVue } from 'bootstrap-vue'
import Scrollspy from 'vue2-scrollspy';
import VueYoutube from 'vue-youtube'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueMasonry from 'vue-masonry-css'
import i18n from './i18n/index'
import './assets/index.css'

import { message } from 'ant-design-vue'
Vue.prototype.$message = message

// Object.keys(directives).forEach((name) => {
//   app.directive(name, directives[name]);
// });

var VueScrollTo = require('vue-scrollto');

Vue.config.productionTip = false

Vue.use(VueScrollTo, {
  duration: 3000,
  easing: "ease"
})

Vue.use(BootstrapVue)
Vue.use(Scrollspy);
Vue.use(VueYoutube)
Vue.use(vueVimeoPlayer)
Vue.use(VueMasonry)

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
